import {
  DynamicField,
  FieldVariant,
  NumberFieldProps,
  SelectFieldProps,
  SwitchFieldProps,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { DynamicFormRepository } from '@/store/dynamic-form-state/dynamic-form.repository';
import { DynaStatus, FormType } from '@/types';
import { capitalize } from 'lodash';
import { emptyFieldObjectFactory } from '@/components/form-builder/utils/single-field-factory';
import { map, of } from 'rxjs';

interface getInspectDynamicFormFormObjectProps {
  store: DynamicFormRepository;
}

export const getInspectDynamicFormFormObject = ({ store }: getInspectDynamicFormFormObjectProps) => {
  const nameField: DynamicField<TextFieldProps> = {
    label: 'transanctionalForm.form.name',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'name'),
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'name'),
      placeholder: 'transanctionalForm.form.placeholders.name',
    },
  };

  const folderTypeField: DynamicField<TextFieldProps> = {
    label: 'transanctionalForm.form.typeDossier',
    variant: FieldVariant.TEXT,
    isRequired: true,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable('response.typeDossier.libelle'),
    },
  };

  const statusField: DynamicField<SwitchFieldProps> = {
    label: 'transanctionalForm.form.status',
    variant: FieldVariant.SWITCH,
    isDisabled: of(true),
    props: {
      checked: store.getNestedObservable<DynaStatus>('dto', 'status').pipe(map(value => value === DynaStatus.ACTIF)),
      placeholder: 'transanctionalForm.form.placeholders.status',
    },
  };

  const formTypeField: DynamicField<SelectFieldProps> = {
    label: 'transanctionalForm.form.formType',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'formType'),
    isDisabled: of(true),
    props: {
      value: store.getObservable('formTypeSelected'),
      placeholder: 'transanctionalForm.form.placeholders.formType',
      options: Object.entries(FormType).map(([key, value]) => ({
        code: FormType[key as keyof typeof FormType],
        name: `transanctionalForm.form.formType${capitalize(value.toString())}`,
      })),
    },
  };

  const orderField: DynamicField<NumberFieldProps> = {
    label: 'transanctionalForm.form.order',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'order'),
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<number>('dto', 'order'),
      placeholder: 'transanctionalForm.form.placeholders.order',
    },
  };

  const formObject = {
    title: 'Formulaire dynamique',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nameField, orderField],
          },
          {
            fields: [folderTypeField, formTypeField],
          },
          {
            fields: [statusField, emptyFieldObjectFactory()],
          },
        ],
      },
    ],
  };

  return formObject;
};
